<!-- @veltra/icons generated sha256:5d4b348f262b59f6 gen:8 source:src/svg/normal/cloud-download.svg -->
<script setup lang="ts">
defineOptions({ name: 'CloudDownload' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m4.018 6.346.354-.042a.51.51 0 0 0 .434-.395l.075-.348C5.197 4.081 6.484 3 8 3s2.803 1.08 3.12 2.561l.077.361a.47.47 0 0 0 .418.38l.367.044C13.104 6.476 14 7.453 14 8.666a2.33 2.33 0 0 1-1.564 2.219c-.244.082-.436.291-.436.549v.007c0 .298.254.53.542.456C13.954 11.528 15 10.22 15 8.667c0-1.715-1.27-3.124-2.903-3.315C11.687 3.43 10.007 2 8 2S4.313 3.429 3.903 5.352C2.269 5.542 1 6.952 1 8.667c0 1.553 1.046 2.861 2.458 3.23.288.075.542-.158.542-.456v-.007c0-.258-.192-.467-.436-.55A2.33 2.33 0 0 1 2 8.668c0-1.214.896-2.19 2.018-2.321m4.485 6.243.938-.935a.507.507 0 0 1 .71-.001.495.495 0 0 1 0 .705l-1.806 1.8a.476.476 0 0 1-.685 0l-1.807-1.8a.495.495 0 0 1-.002-.702.51.51 0 0 1 .713-.002l.938.935V8.502c0-.276.209-.505.486-.505h.01c.277 0 .505.229.505.505z"
    />
  </svg>
</template>
